export const API_STATUS = "API_STATUS";
export const FETCH_AUDIT_ROWS = "FETCH_AUDIT_ROWS";